import React, { Component } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert';

class Ticket extends Component{
    constructor(){
        super()
        this.state={
            open: false
        }
    }
    hideSweetAlert = () => {
        this.setState({ open: false, selected:''})
        this.props.deleteSeatCart(this.state.selected)
    }
    showSweetAlert = (e) => {
        let selected = e.target.getAttribute('data-index')
        this.setState({ open: true, selected })
    }

    render(){
    return (
        <div className="ticket__container">
            <div className="row">
                <div className="col-md-1 col-sm-12">
                    <span className="float-lg-left delete-seat-cart" ><i data-index={this.props.dataIndex} onClick={this.showSweetAlert} className="fa fa-times"></i></span>
                </div>
                <div className="col-md-5 col-sm-12">
                    <span className="float-lg-left">{this.props.ticketName} - <strong>{this.props.seat}</strong></span>
                </div>
                <div className="col-md-3 col-sm-12">
                    <span className="float-lg-right">RD$ {this.props.price}</span>
                </div>
                <div className="col-md-3 col-sm-12">
                    <span className="float-lg-right"><input type='checkbox' onChange={this.props.changeInvited} data-index={this.props.dataIndex} checked={this.props.invited} /> Invitado</span>
                </div>
            </div>
            <SweetAlert
                warning
                show={this.state.open}
                showCancel
                confirmBtnText="Confirmar"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="default"
                cancelBtnText="Cancelar"
                title="¿Desea continuar?"
                onConfirm={this.hideSweetAlert}
                onCancel={this.hideSweetAlert}
            >
                Presione confirmar para eliminar la reserva.
                </SweetAlert>
        </div>
        )
    }
}

export default Ticket;


// WEBPACK FOOTER //
// ./src/Components/Ticket/ticketConfirm.js